"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DecodedObject = /** @class */ (function () {
    function DecodedObject(newPosition) {
        this.newPosition = newPosition;
    }
    DecodedObject.prototype.getNewPosition = function () {
        return this.newPosition;
    };
    return DecodedObject;
}());
exports.default = DecodedObject;



//////////////////
// WEBPACK FOOTER
// ./~/@zxing/library/cjs/core/oned/rss/expanded/decoders/DecodedObject.js
// module id = 231
// module chunks = 4